module.exports = __webpack_public_path__ + "static/media/team-introduction-8.9e598689.jpg";